// ------------------------------------
// Import SCSS files
// ------------------------------------

import "../sass/base.scss";

// ------------------------------------
// Import JS files
// ------------------------------------
import "./components/search-form";
import "./components/header";